import { a as setPlatformHelpers } from './index-97874de0.js';

/*
 * SPDX-FileCopyrightText: 2024 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function shouldDefineIcons() {
    var _a, _b;
    const content = (_b = (_a = document.head) === null || _a === void 0 ? void 0 : _a.querySelector('meta[name="ix:legacy-icons"]')) === null || _b === void 0 ? void 0 : _b.getAttribute('content');
    if (!content) {
        return true;
    }
    return content.toLowerCase() === 'true';
}
async function setupIcons() {
    if (typeof window === 'undefined') {
        return;
    }
    if (shouldDefineIcons() === false) {
        return;
    }
    const iconComponent = window.customElements.get('ix-icon');
    if (iconComponent) {
        return;
    }
    const ixIcons = await import('./index.es2017-4e6fdf77.js').then(function (n) { return n.i; });
    await ixIcons.defineCustomElements();
}
function handlePlatformHelpers(config) {
    const platformHelpers = {};
    if (config.ael) {
        platformHelpers.ael = config.ael;
    }
    if (config.rel) {
        platformHelpers.rel = config.rel;
    }
    if (config.ce) {
        platformHelpers.ce = config.ce;
    }
    setPlatformHelpers(platformHelpers);
}
async function appGlobalScript (config) {
    await setupIcons();
    handlePlatformHelpers(config || {});
}

export { appGlobalScript as a, handlePlatformHelpers as h };

//# sourceMappingURL=setup-3a3f57db.js.map